<template>
<span>
  <b-tooltip label="Push prospect to Orion Astro"
    position="is-bottom"
  >
    <b-button
      label="Push to Astro"
      type="is-info"
      size="is-default"
      icon-pack="fas"
      icon-left="cloud-upload-alt"
      v-bind:loading="in_progress"
      @click="sendToOrionAstro()"
      outlined
    />
  </b-tooltip>
</span>
</template>

<script>
/* 
-- Requires --
User with feature `Orion Prospect Creation`

-- Props --
prospect: Prospect.external_id
holdings: [
    {
        'ticker': Ticker.symbol,
        'shares': int,
        'price': int,
        'purchase_date': str YYYY-MM-DD,
        'face_value': int,
        'purchase_price': int
    }
]

-- Markup --
<div class="control">
    <AstroProspectButton
    v-show="$root.advisor.hasFeature('Orion Prospect Creation')" 
    prospect="" 
    holdings=[] />
</div>
*/


  export default {
    data() {
      return {
        in_progress: false
      }
    },
    props: {
      prospect_external_id: String,
      holdings: Array
    },
    methods: {
        sendToOrionAstro: async function() {
        this.in_progress = true;
        await fetch(
            '/api/v1/integrations/orion/astro/prospect/',
            {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-CSRFToken': this.$root.$data.csrfToken,
              },
              body: JSON.stringify({
                  'prospect': this.prospect_external_id,
                  'holdings': this.holdings
              }),
            }).then((response) => {
            if (response.ok) {
              response.json().then((data) => {
                this.$buefy.toast.open('Pushed!');
              });
            }
            else {
              response.json().then((data) => {
                alert('There was an error pushing, please try again.');
              });
            }
            });
            this.in_progress = false;
        }
    }
  }
</script>
<style>
</style>
